import React, { FunctionComponent } from "react";
import Select, { components } from "react-select";
import { MenuItems, MenuItem } from "../../../../components/@types";
import Icon from "../../../../components/Icon";

interface IYaraSelectInputProps {
  label: string;
  placeholder: string;
  items?: MenuItems;
  active?: MenuItem;
  disabled?: boolean;
  onChange: (value?: MenuItem) => void;
  allLabel?: string;
}

const DropdownIndicator = (props: any) => (
  <components.DropdownIndicator {...props}>
    <Icon name={"chevron-down"} />
  </components.DropdownIndicator>
);

const ALL_MENU_VALUE = "all";

const YaraSelectInput: FunctionComponent<IYaraSelectInputProps> = ({
  items,
  active,
  label,
  placeholder,
  disabled,
  onChange,
  allLabel = "All"
}) => (
  <div>
    <div>{label}:</div>
    <Select
      key={`${label}-${active?.value}`}
      options={[{ value: ALL_MENU_VALUE, label: allLabel }, ...(items ?? [])]}
      onChange={newValue => {
        if (newValue == null || newValue.value === ALL_MENU_VALUE) {
          onChange(undefined);
        } else {
          onChange(newValue);
        }
      }}
      isDisabled={disabled}
      value={active}
      placeholder={placeholder}
      styles={{
        input: base => ({ ...base, width: 150 }),
        menu: base => ({ ...base, zIndex: 100 })
      }}
      components={{ IndicatorSeparator: null, DropdownIndicator }}
    />
  </div>
);

export default YaraSelectInput;
